/* eslint-disable no-param-reassign */
import { createAction, createReducer } from 'utils/reducer';

// Local constants
const PATH = 'lotTraceability/';
const CHANGE_CONTROLS = `${PATH}CHANGE_CONTROLS`;

export const LOT_TRACEABILITY = {
  GET_STATE_FROM_API: `${PATH}GET_STATE_FROM_API`,
  GET_STATE_FROM_API_SUCCESS: `${PATH}GET_STATE_FROM_API_SUCCESS`,
};

export const lotTraceabilityActions = {
  getStateFromApi: createAction(LOT_TRACEABILITY.GET_STATE_FROM_API, 'controls'),
  changeControls: createAction(CHANGE_CONTROLS, 'controls'),
};

const initialState = {
  traceabilityReport: [],
  traceabilityGraph: null,
  loading: true,
  controls: {
    lotIds: [],
    lotNumber: null,
  },
};

const reducer = createReducer(initialState, {
  [LOT_TRACEABILITY.GET_STATE_FROM_API](state) {
    state.traceabilityReport = initialState.traceabilityReport;
    state.traceabilityGraph = initialState.traceabilityGraph;
    state.loading = true;
  },
  [LOT_TRACEABILITY.GET_STATE_FROM_API_SUCCESS](state, action) {
    state.traceabilityReport = action.payload.traceabilityReport;
    state.traceabilityGraph = action.payload.traceabilityGraph || initialState.traceabilityGraph;

    if (action.payload.status === 'loading') {
      state.loading = true;
      return;
    }

    if (action.payload.traceabilityGraph) {
      state.loading = false;
      return;
    }

    state.loading = !action.payload.traceabilityReport.length;
  },
  [CHANGE_CONTROLS](state, action) {
    state.controls = { ...state.controls, ...action.controls };
  },
});

export default reducer;
